import styled, { css } from 'styled-components';

export const TabsWrapper = styled.div`
  user-select: none;
  cursor: pointer;

  ${({ theme }) => theme.breakpoints.down('md')} {
    overflow: scroll;
  }
`;

export const TabsHeader = styled.div`
  display: flex;
  font-size: 30px;
  list-style-type: none;
  padding: unset;
  margin: unset;
  margin-bottom: 20px;

  /* this is fixing the "jumpy" behavior when clicking from the first tab to another tab */
  height: 41px;
`;

export const TabsHeaderBody = styled.div<{ selectedTab: boolean }>`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  width: 123px;
  color: rgba(0, 0, 0, 0.63);
  padding: 0 20px 10px 20px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ selectedTab }) =>
    selectedTab &&
    css`
      color: rgba(0, 0, 0, 0.94);
      font-weight: 500;

      border-bottom: 3px solid #209ad6;
    `}

  ${({ theme }) => theme.breakpoints.down('md')} {
    min-width: 120px;
  }
`;
